import { Badge, type BadgeProps } from '@zorro/design-system/v2/Badge';
import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { Box } from '@zorro/web/design-system';
import { ReactNode } from 'react';

type PlanBadgeSize = 'xs' | 'sm' | 'md';

type Props = {
  leftSide?: ReactNode;
  size?: PlanBadgeSize;
  label: string | ReactNode;
  tooltipLabel?: string;
  /** @deprecated Temporary prop — do not use */
  variant?: BadgeProps['variant'];
} & Omit<BadgeProps, 'children' | 'leftSection'>;

const sizeToVariant = (size: PlanBadgeSize): BadgeProps['variant'] =>
  size === 'md' ? 'manual' : 'simple';

export const PlanBadge = ({
  leftSide,
  size = 'md',
  label,
  tooltipLabel,
  variant,
  color = 'gray',
  ...props
}: Props) => {
  const pill = (
    <Badge
      variant={variant || sizeToVariant(size)}
      leftSection={leftSide}
      color={color}
      {...props}
    >
      {label}
    </Badge>
  );

  return tooltipLabel ? (
    <Tooltip label={tooltipLabel} position="top" shouldStopPropagation>
      <Box pos="relative" display="inline-flex">
        {pill}
      </Box>
    </Tooltip>
  ) : (
    pill
  );
};
